import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class MonthDayYearDateParserFormatter implements NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const regExMatch = datePattern.exec(value);
    if (regExMatch != null)
      return { month: parseInt(regExMatch[1]), day: parseInt(regExMatch[2]), year: parseInt(regExMatch[3]) };

    const datePatternNoSlashes = /^(\d{2})(\d{2})(\d{4})$/
    const regExMatchNoSlashes = datePatternNoSlashes.exec(value);
    if (regExMatchNoSlashes != null)
      return { month: parseInt(regExMatchNoSlashes[1]), day: parseInt(regExMatchNoSlashes[2]), year: parseInt(regExMatchNoSlashes[3]) };

    return null;
  }

  format(date: NgbDateStruct): string {
    if (date == null)
      return "";

    return this.padNumber(date.month) + "/" + this.padNumber(date.day) + "/" + date.year;
  }

  private padNumber(value: number) {
    if (this.isNumber(value)) {
      return `0${value}`.slice(-2);
    } else {
      return '';
    }
  }

  private isNumber(value: any): value is number {
    return !isNaN(this.toInteger(value));
  }

  private toInteger(value: any): number {
    return parseInt(`${value}`, 10);
  }
}
